const UserStatus = {
  CURRENT_USER: 'current',
  ANONYMOUS_USER: 'anonymous',
};

export {UserStatus};
